var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_User_Line",
    "data-name": "icons/User/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.333,16.667a34.851,34.851,0,0,1-4.549-.308A4,4,0,0,1,.308,12.882,34.829,34.829,0,0,1,0,8.333,34.851,34.851,0,0,1,.308,3.784,4,4,0,0,1,3.784.308,34.851,34.851,0,0,1,8.333,0a34.829,34.829,0,0,1,4.549.308,4,4,0,0,1,3.477,3.477,34.851,34.851,0,0,1,.308,4.549,34.829,34.829,0,0,1-.308,4.549,4,4,0,0,1-3.477,3.477A34.829,34.829,0,0,1,8.333,16.667Zm0-15A33.216,33.216,0,0,0,4,1.96,2.349,2.349,0,0,0,1.96,4a33.216,33.216,0,0,0-.293,4.331,33.216,33.216,0,0,0,.293,4.33A2.349,2.349,0,0,0,4,14.707,33.216,33.216,0,0,0,8.333,15a33.216,33.216,0,0,0,4.33-.293,2.349,2.349,0,0,0,2.043-2.043A33.216,33.216,0,0,0,15,8.333,33.216,33.216,0,0,0,14.707,4,2.349,2.349,0,0,0,12.664,1.96,33.216,33.216,0,0,0,8.333,1.666Z",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M.53,9.609h0A2.413,2.413,0,0,1,.087,8.5C.056,8.258.026,8.018,0,7.782L1.359,6.423a2.5,2.5,0,0,1,3.536,0l.142.142a.834.834,0,0,0,1.179,0l1.809-1.81a2.5,2.5,0,0,1,3.536,0l1.5,1.5c-.048.717-.118,1.439-.21,2.147L10.383,5.935a.833.833,0,0,0-1.178,0l-1.81,1.81a2.5,2.5,0,0,1-3.535,0L3.716,7.6a.833.833,0,0,0-1.178,0L.531,9.608ZM3.961,3.333A1.666,1.666,0,1,1,5.627,1.667,1.669,1.669,0,0,1,3.961,3.333Z",
    transform: "translate(1.873 4.167)",
    fill: "#777e90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn2Icon);
export default __webpack_public_path__ + "static/media/btn2icon.6072baa5ea341a47a1fa7c81f4d6963c.svg";
export { ForwardRef as ReactComponent };